import { identity } from "@core/foundation/function";
import {
  createModel,
  createModelSchemas,
  noModelUpdate,
} from "@core/foundation/model";
import { z } from "@core/zod";

export const GithubWorkflowRun = createModel({
  create: (item, schema) => schema.decode(item),
  schemas: createModelSchemas({
    base: z.object(
      {
        conclusion: z
          .enum([
            "action_required",
            "cancelled",
            "failure",
            "neutral",
            "skipped",
            "stale",
            "startup_failure",
            "success",
            "timed_out",
          ])
          .nullable(),
        createdAt: z.string(),
        event: z.string(),
        headBranch: z.string().nullable(),
        headSha: z.string(),
        htmlUrl: z.url(),
        id: z.int().positive(),
        name: z.string().nullable(),
        startedAt: z.string().nullable(),
        status: z
          .enum([
            "completed",
            "in_progress",
            "pending",
            "queued",
            "requested",
            "waiting",
          ])
          .nullable(),
        workflowPath: z.string(),
      },
      {
        conclusion: "The run's conclusion, or null until the run completes.",
        createdAt: "When GitHub created the run.",
        event: "The event that triggered the run.",
        headBranch:
          "The branch the run ran on, or null when GitHub names none.",
        headSha: "The SHA of the commit the run ran on.",
        htmlUrl: "The run's page on GitHub.",
        id: "The run's GitHub id.",
        name: "The workflow's name, or null when GitHub names none.",
        startedAt: "When the run started, or null when GitHub reports none.",
        status: "The run's status, or null when GitHub reports none.",
        workflowPath: "The path of the run's workflow file in the repo.",
      },
    ),
    derive: { create: identity, recovery: identity, update: noModelUpdate },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface GithubWorkflowRun
  extends z.infer<typeof GithubWorkflowRun.schema> {}
